import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import { TEXT_FAQ } from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BANNER_BLUE,
  STYLE_HEADING_1,
  STYLE_MARGIN_TOP,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";

const FaqBanner = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 150);
  }, []);
  return (
    <div
      className={`${STYLE_BANNER_BLUE} ${STYLE_MARGIN_TOP}`}
      style={{
        backgroundImage:
          show && isMobile
            ? `url(/images/faq_banner_mb.svg)`
            : `url(/images/bg_blue_contactus.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "cover",
      }}
    >
      {!isMobile && show && (
        <img
          src={"/images/faq_img.png"}
          className={`border-none  h-[187px] md:h-img_banner mx-auto absolute bottom-0 left-1/2 transform -translate-x-1/2 `}
        />
      )}
      <div className={`${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP} `}>
        <ProgramGoBack
          title={TEXT_FAQ[language]}
          textcolor={`${STYLE_HEADING_1(language)}`}
          marginarrow="md:ml-9"
          absolute={`${
            language === "TH"
              ? "left-[25%] md:left-1/2 md:transform md:-translate-x-1/2"
              : "left-1/2 transform -translate-x-1/2"
          }`}
        />
      </div>
    </div>
  );
};

export default FaqBanner;
